import {UserEventsSharedWorker} from '../modules/worker.ts';

const {appSubUrl, notificationSettings} = window.config;

class PreviewLoader {
  usingEventSource: boolean;
  worker: SharedWorker;
  stopPolling: boolean;

  constructor(sourceParams: Record<string, unknown>, readyCallback: () => void, errorCallback: () => void) {
    errorCallback = errorCallback ?? this.error.bind(this);
    if (notificationSettings.EventSourceUpdateTime > 0 && Boolean(window.EventSource) && window.SharedWorker) {
      // CREATE SHARED WORKER
      this.usingEventSource = true;
      // UserEventsSharedWorker constructs the worker, posts the "start" message and wires
      // the "beforeunload" cleanup. The bespoke message handling below is attached to its port.
      const userEventsWorker = new UserEventsSharedWorker('notification-worker');
      this.worker = userEventsWorker.sharedWorker;
      this.worker.port.addEventListener('message', (event) => {
        if (!event.data || !event.data.type) {
          console.error(event);
          return;
        }
        if (event.data.type === 'image-preview-ready') {
          const eventParams = JSON.parse(event.data.data);
          if (_isSubset(eventParams, sourceParams)) {
            // This is our event. Check for errors.
            if (eventParams.isError) {
              errorCallback();
            } else {
              // Add a small delay and run the callback
              setTimeout(() => {readyCallback()}, 50);
            }
            if (this.worker) {
              this.worker.port.close();
            }
          }
        } else if (event.data.type === 'status') {
          // Handle the case when we missed the ready message while loading.
          if (event.data.message && (JSON.parse(event.data.message).readyState === EventSource.OPEN)) {
            // If the port is already open we should immediately try to fetch data in case we've missed the event.
            //   Otherwise, wait for the event open event.
            readyCallback();
          }
        } else if (event.data.type === 'open') {
          // Handle the case when we missed the ready message while loading, on
          // the first tab only.
          //
          // This event only triggers the first time the shared event source is
          // created.
          readyCallback();
        } else if (event.data.type === 'error') {
          console.error(event.data);
        } else if (event.data.type === 'logout') {
          if (event.data !== 'here') {
            return;
          }
          if (this.worker) {
            this.worker.port.postMessage({
              type: 'close',
            });
            this.worker.port.close();
          }
          window.location.href = appSubUrl;
        }
      });
      userEventsWorker.startPort();
    } else {
      const checkReady = () => {
        if (this.stopPolling) {
          return;
        }
        readyCallback();
      };

      setTimeout(checkReady, 0);
    }
  }

  // Cancel event source and clean up worker
  cancel() {
    // Is there any other cleanup we need to do here?
    if (this.usingEventSource) {
      if (this.worker) {
        this.worker.port.close();
      }
    } else {
      this.stopPolling = true;
    }
  }

  // Default error callback
  error() {
    console.error('Server encountered an error generating preview');
    this.cancel();
  }
}

// Return true if all of the parameters in object subset exist and are equal in superset
function _isSubset(superset: Record<string, unknown>, subset: Record<string, unknown>): boolean {
  return Object.keys(subset).every((key) => {
    return (superset[key] === subset[key]);
  });
}

export {PreviewLoader};
